import React, { useState } from 'react';
import InfoTooltip from '../../common/InfoTooltip';

const CollapsibleSection = ({ title, children, defaultOpen = false, isOpen, onToggle, sectionId, infoText }) => {
  return (
    <div className="collapsible-section" style={{ marginBottom: '1rem' }}>
      {isOpen ? (
        // When expanded: wrap header and content in single background container
        <div style={{ background: '#fafbfc', border: '1px solid #eee', borderRadius: '12px' }}>
          <div
            className="collapsible-header"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', fontWeight: 600, fontSize: '1rem', padding: '0.75rem' }}
            onClick={() => onToggle(sectionId)}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>{title}</span>
              
              {infoText && (
                <InfoTooltip iconSize={14}>
                  {infoText}
                </InfoTooltip>
              )}
            </div>
            <span style={{ fontSize: '1.25rem', color: '#888' }}>−</span>
          </div>
          <div className="collapsible-content" style={{ padding: '0.75rem', paddingTop: '0px' }}>  
            {children}
          </div>
        </div>
      ) : (
        // When collapsed: just the header with background
        <div
          className="collapsible-header"
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', fontWeight: 600, fontSize: '1rem', padding: '0.75rem', borderRadius: '12px', background: '#fafbfc', border: '1px solid #eee' }}
          onClick={() => onToggle(sectionId)}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>{title}</span>
            {infoText && (
              <InfoTooltip iconSize={14}>
                {infoText}
              </InfoTooltip>
            )}
          </div>
          <span style={{ fontSize: '1.25rem', color: '#888' }}>+</span>
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection; 